<div [style.--phase-icon-color]="colorClass()">
  <p-button
    size="small"
    styleClass="phase-action-button"
    [icon]="icon()"
    [text]="true"
    [disabled]="disabled()"
    [pTooltip]="tooltip() | transloco"
    tooltipPosition="top"
    (onClick)="open()"
  />
</div>

<app-base-dialog
  [visible]="visible()"
  (visibleChange)="visible.set($event)"
  [title]="header()"
  [testId]="testId()"
  [dialogStyleClass]="dialogStyleClass()"
  cancelLabel="common.close"
>
  <div class="flex flex-col h-full">
    <p-divider />
    <div class="flex-1 overflow-auto">
      <ng-content />
    </div>
    <p-divider />
  </div>
</app-base-dialog>
